/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ChevronDown = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.9545 14.185L6.46984 8.70022L5.40918 9.76088L10.8938 15.2457L11.9545 16.2002L13.0152 15.2457L18.5 9.76073L17.4393 8.70007L11.9545 14.185Z"
                        fill={color}
                    />
                </svg>
        );
    };
